import { type } from '@sparling/financial-common'

const types = []

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const item of type) {
  types.push({
    value: item,
    label: item,
  })
}

export const CRM_TRANSACTION_TYPE = types
